import { Economy } from "@highmarch/app";
import { GearItem, sellBlocker, sellPrice, sellRefund } from "@highmarch/domain";
import { toast } from "../toast";
import { economyLink } from "./economyLink";
import { marksIcon } from "./econArt";
import { confirmSale } from "./marketSheet";
import { sellRows } from "./marketModel";
import { econCue, flyCurrency } from "./purchaseFx";
import { refusalText } from "./shopActions";

/**
 * "Sell to the Trading Post" on the Armoury's item card (FINISH_PLAN WP5, M13): the same sale as More → Market's Sell
 * page, from the card of the item itself. Rare+ only; a worn or locked item shows why it can't go yet. Returns null
 * (no row) below the Trading Post's rarity or when the economy is not linked (tests, a level).
 */
export function tradeSellRow(item: GearItem, toastParent: HTMLElement, onSold: () => void): HTMLElement | null {
  const link = economyLink();
  if (!link) return null;
  const B = link.catalog.balance;
  if (item.rarity < B.commerce.market.minSellRarity) return null;
  const blocked = sellBlocker(B, item);
  const row = document.createElement("div");
  row.className = "tradesell";
  // Gear v2: a sale also gives back half the essence spent raising it (domain sellRefund).
  const back = blocked ? 0 : sellRefund(B, item);
  // M30 #8: the button says the whole deal ("Sell at the Trading Post for 1,200 Marks"); the line under it says why not.
  const why = blocked === "equipped" ? "Unequip it to sell it" : blocked === "locked" ? "Unlock it to sell it" : blocked === "bound" ? "Bound gear can't be traded"
    : back > 0 ? `Pays more than salvage, and +${back} essence back` : "Pays more than salvage";
  const price = sellPrice(B, item).toLocaleString("en-US");
  row.innerHTML = `<button class="btn blue ts-go" ${blocked ? "disabled" : ""} aria-label="Sell at the Trading Post for ${price} Marks"><span class="ts-l">Sell at the Trading Post for</span><span class="price marks">${marksIcon(18)}<b>${price}</b></span></button><small class="ts-why">${why}</small>`;
  if (blocked) row.classList.add("off");
  row.querySelector<HTMLButtonElement>(".ts-go")!.onclick = async () => {
    const r = sellRows(link.catalog).rows.find((x) => x.item.id === item.id);
    if (!r || !(await confirmSale(toastParent, B, r, true))) return;
    const eco = new Economy(link.catalog), before = eco.wallet.marks;
    const sold = eco.sellToTradingPost(item.id, link.now(), r.mythic);
    if (typeof sold === "string") { toast(toastParent, refusalText(sold)); return; }
    econCue("sell");
    link.hub?.changed();
    flyCurrency(row, "marks", before, eco.wallet.marks);     // reads the row's place before the card closes
    onSold();
    toast(toastParent, `Sold for ${sold.marks} Marks`);
  };
  return row;
}
